<template>
  <v-card tile>
    <v-card-title class="py-2" @click="show = !show" style="cursor: pointer;">
      <h3>{{instance.title}}</h3>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>{{ show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text v-show="show && !is_empty">
      <h3>Video</h3>
      <v-layout>
        <v-flex xs6 class="py-2">Input mode</v-flex>
        <v-flex xs6 class="py-2">{{video_input_mode}}</v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs6 class="py-2">Output mode</v-flex>
        <v-flex xs6 class="py-2">
          <v-select
            :items="available_video_modes"
            :value="video_output_mode"
            @change="change_video_output_mode"
            hide-details
            single-line
            height="20"
            class="pa-0 ma-0"
            item-text="name"
            item-value="value">
          </v-select>
        </v-flex>
      </v-layout>
      <v-divider class="my-3"></v-divider>
      <h3>Audio</h3>
      <v-layout>
        <v-flex xs6 font-weight-bold class="py-2">Output</v-flex>
        <v-flex xs6 font-weight-bold class="py-2">Input</v-flex>
      </v-layout>
      <template v-for="ch in audio_output_channels">
        <v-layout>
          <v-flex xs6 class="py-2">{{ch.name}}</v-flex>
          <v-flex xs6 class="py-2">
            <v-select
              :items="audio_input_channels"
              :value="get_audio_channel(ch.value)"
              @change="change_audio_channel($event, ch.value)"
              hide-details
              single-line
              height="20"
              class="pa-0 ma-0"
              item-text="name"
              item-value="value">
            </v-select>
          </v-flex>
        </v-layout>
      </template>
      <!--
      <template v-for="(values, setting) in settings">
        <h3 class="pb-2 pt-4">{{setting}}</h3>
        <v-layout>
          <v-flex xs6 font-weight-bold class="py-2">Name</v-flex>
          <v-flex xs6 font-weight-bold class="py-2">Value</v-flex>
        </v-layout>
        <v-layout v-for="(value, name) in sort_values(values)" :key="setting+'_'+name" style="border-bottom: 1px solid hsla(0,0%,100%,.12);">
          <v-flex xs6 class="py-2">{{name}}</v-flex>
          <v-flex xs6 class="py-2">{{value}}</v-flex>
        </v-layout>
      </template>-->
    </v-card-text>
  </v-card>
</template>

<script>
import naturalSort from 'natural-sort'
import InstanceModel from '@/models/instance.js'

_.mixin({
  sortWith : function(arr, customFn) {
    return _.map(arr).sort(customFn)
  }
});

export default {
  props: ['id'],
  data () {
    var ch = this.$cloudserver.channel("instances:status:"+this.id);
    return {
      show: false,
      available_video_modes: [
        {name: "1080p50", value: "1080p50"},
        {name: "1080i50", value: "1080i50"}
      ],
      audio_input_channels: [
        {name: "Input ch 1", value: "AudioIn1"},
        {name: "Input ch 2", value: "AudioIn2"},
        {name: "Input ch 3", value: "AudioIn3"},
        {name: "Input ch 4", value: "AudioIn4"},
        {name: "Input ch 5", value: "AudioIn5"},
        {name: "Input ch 6", value: "AudioIn6"},
        {name: "Input ch 7", value: "AudioIn7"},
        {name: "Input ch 8", value: "AudioIn8"}
      ],
      audio_output_channels: [
        {name: "Output ch 1", value: "AudioOut0"},
        {name: "Output ch 2", value: "AudioOut1"},
        {name: "Output ch 3", value: "AudioOut2"},
        {name: "Output ch 4", value: "AudioOut3"},
        {name: "Output ch 5", value: "AudioOut4"},
        {name: "Output ch 6", value: "AudioOut5"},
        {name: "Output ch 7", value: "AudioOut6"},
        {name: "Output ch 8", value: "AudioOut7"}
      ],
      ws_channel: ch
    }
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
    instance () {
			return InstanceModel.instance_by_id(this.id);
		},
    settings() {
      return _.get(this.ws_channel.data, "instance", {})
    },
    is_empty() {
      return _.isEmpty(this.settings);
    },
    video_output_mode () {
      return _.get(this.settings, ["video_output", "Video mode"])
    },
    video_input_mode () {
      return _.get(this.settings, ["video_input", "Video mode"])
    },
    audio () {
      return _.get(this.settings, "audio")
    }
  },
  methods: {
    get_audio_channel (out_ch) {
      return _.get(this.audio, out_ch);
    },
    sort_values(values) {
      return _(values).toPairs().sortWith(naturalSort()).fromPairs().value();
    },
    change_video_output_mode (mode) {
      InstanceModel.send_command_to_external_device(this.instance, "change-setting", {name: "video_output", key: "Video mode", value: mode}, () => {}, () => {});
    },
    change_audio_channel (in_ch, out_ch) {
      InstanceModel.send_command_to_external_device(this.instance, "change-setting", {name: "audio", key: out_ch, value: in_ch}, () => {}, () => {});
    }
  }
}
</script>
